module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('swiper', {
    ref: "mySwiper",
    staticClass: "swiper-box",
    class: {
      'hide': !_vm.isPdfActive
    },
    attrs: {
      "options": _vm.swiperOption
    }
  }, [_c('swiper-slide', {
    staticClass: "swiper-item"
  }, [_c('button', {
    staticClass: "close-btn",
    on: {
      "click": _vm.close
    }
  }, [_c('svg', {
    staticStyle: {
      "width": "28px",
      "height": "28px"
    },
    attrs: {
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#FFF",
      "d": "M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z"
    }
  })])]), _vm._v(" "), _c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: ({
        src: '../../static/img/brochure-a.jpg',
        error: '',
        loading: '../../static/img/preload.gif'
      }),
      expression: "{\n        src: '../../static/img/brochure-a.jpg',\n        error: '',\n        loading: '../../static/img/preload.gif'\n      }"
    }],
    staticClass: "pdf-page"
  })]), _vm._v(" "), _c('swiper-slide', {
    staticClass: "swiper-item"
  }, [_c('button', {
    staticClass: "close-btn",
    on: {
      "click": _vm.close
    }
  }, [_c('svg', {
    staticStyle: {
      "width": "28px",
      "height": "28px"
    },
    attrs: {
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#FFF",
      "d": "M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z"
    }
  })])]), _vm._v(" "), _c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: ({
        src: '../../static/img/brochure-b.jpg',
        error: '',
        loading: '../../static/img/preload.gif'
      }),
      expression: "{\n        src: '../../static/img/brochure-b.jpg',\n        error: '',\n        loading: '../../static/img/preload.gif'\n      }"
    }],
    staticClass: "pdf-page"
  })]), _vm._v(" "), _c('swiper-slide', {
    staticClass: "swiper-item"
  }, [_c('button', {
    staticClass: "close-btn",
    on: {
      "click": _vm.close
    }
  }, [_c('svg', {
    staticStyle: {
      "width": "28px",
      "height": "28px"
    },
    attrs: {
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#FFF",
      "d": "M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z"
    }
  })])]), _vm._v(" "), _c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: ({
        src: '../../static/img/brochure-c.jpg',
        error: '',
        loading: '../../static/img/preload.gif'
      }),
      expression: "{\n        src: '../../static/img/brochure-c.jpg',\n        error: '',\n        loading: '../../static/img/preload.gif'\n      }"
    }],
    staticClass: "pdf-page"
  })]), _vm._v(" "), _c('swiper-slide', {
    staticClass: "swiper-item"
  }, [_c('button', {
    staticClass: "close-btn",
    on: {
      "click": _vm.close
    }
  }, [_c('svg', {
    staticStyle: {
      "width": "28px",
      "height": "28px"
    },
    attrs: {
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#FFF",
      "d": "M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z"
    }
  })])]), _vm._v(" "), _c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: ({
        src: '../../static/img/brochure-d.jpg',
        error: '',
        loading: '../../static/img/preload.gif'
      }),
      expression: "{\n        src: '../../static/img/brochure-d.jpg',\n        error: '',\n        loading: '../../static/img/preload.gif'\n      }"
    }],
    staticClass: "pdf-page"
  })]), _vm._v(" "), _c('swiper-slide', {
    staticClass: "swiper-item"
  }, [_c('button', {
    staticClass: "close-btn",
    on: {
      "click": _vm.close
    }
  }, [_c('svg', {
    staticStyle: {
      "width": "28px",
      "height": "28px"
    },
    attrs: {
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#FFF",
      "d": "M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z"
    }
  })])]), _vm._v(" "), _c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: ({
        src: '../../static/img/brochure-e.jpg',
        error: '',
        loading: '../../static/img/preload.gif'
      }),
      expression: "{\n        src: '../../static/img/brochure-e.jpg',\n        error: '',\n        loading: '../../static/img/preload.gif'\n      }"
    }],
    staticClass: "pdf-page"
  })]), _vm._v(" "), _c('swiper-slide', {
    staticClass: "swiper-item"
  }, [_c('button', {
    staticClass: "close-btn",
    on: {
      "click": _vm.close
    }
  }, [_c('svg', {
    staticStyle: {
      "width": "28px",
      "height": "28px"
    },
    attrs: {
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#FFF",
      "d": "M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z"
    }
  })])]), _vm._v(" "), _c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: ({
        src: '../../static/img/brochure-f.jpg',
        error: '',
        loading: '../../static/img/preload.gif'
      }),
      expression: "{\n        src: '../../static/img/brochure-f.jpg',\n        error: '',\n        loading: '../../static/img/preload.gif'\n      }"
    }],
    staticClass: "pdf-page"
  })]), _vm._v(" "), _c('swiper-slide', {
    staticClass: "swiper-item"
  }, [_c('button', {
    staticClass: "close-btn",
    on: {
      "click": _vm.close
    }
  }, [_c('svg', {
    staticStyle: {
      "width": "28px",
      "height": "28px"
    },
    attrs: {
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#FFF",
      "d": "M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z"
    }
  })])]), _vm._v(" "), _c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: ({
        src: '../../static/img/brochure-g.jpg',
        error: '',
        loading: '../../static/img/preload.gif'
      }),
      expression: "{\n        src: '../../static/img/brochure-g.jpg',\n        error: '',\n        loading: '../../static/img/preload.gif'\n      }"
    }],
    staticClass: "pdf-page"
  })]), _vm._v(" "), _c('swiper-slide', {
    staticClass: "swiper-item"
  }, [_c('button', {
    staticClass: "close-btn",
    on: {
      "click": _vm.close
    }
  }, [_c('svg', {
    staticStyle: {
      "width": "28px",
      "height": "28px"
    },
    attrs: {
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#FFF",
      "d": "M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z"
    }
  })])]), _vm._v(" "), _c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: ({
        src: '../../static/img/brochure-h.jpg',
        error: '',
        loading: '../../static/img/preload.gif'
      }),
      expression: "{\n        src: '../../static/img/brochure-h.jpg',\n        error: '',\n        loading: '../../static/img/preload.gif'\n      }"
    }],
    staticClass: "pdf-page"
  })]), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination",
    attrs: {
      "slot": "pagination"
    },
    slot: "pagination"
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-prev",
    attrs: {
      "slot": "button-prev"
    },
    slot: "button-prev"
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-next",
    attrs: {
      "slot": "button-next"
    },
    slot: "button-next"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-48693e3b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pdf.vue
// module id = 260
// module chunks = 6